<template>
  <div id="app">
    <welcome-bar style="margin-bottom: 2em;"/>
    <router-view/>
    <footer>
      <!-- ТАПАСУ — ТАПАС -->
    </footer>
  </div>
</template>

<style lang="scss">

// #nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>

<script>
import WelcomeBar from './components/WelcomeBar.vue'

export default {
  components: {
    WelcomeBar
  }
}
</script>


<style lang="scss">
@import './assets/scss/application.scss';
@import './assets/scss/_grid.scss';

.panel-above-map {
    display: flex;
    justify-content: space-between;

    .buttons {
        display: flex;
        gap: 1em;
    }

    button {
        font-size: 0.75em;
        font-weight: 600;

        border-radius: 1.2em;
    }
}

.main-text {
    margin-top: 2em;
}


// footer {
//   background-color: black;
//   height: 200px;
//   font-size: 5em;
//   color: white;
//   font-family: "e-Ukraine";
//   font-weight: 600;
  
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   display: none;
// }

:root {
  // --col-highlight: #FFF7E3;
  --col-interactive-bg: #E7EEF3;
  --col-highlight-bg: #FFF7E3;

  --diia-gradient: linear-gradient(90deg, #4f4fff, #bb829e);  

  --sz-mobile: 800px;
}

.highlight {
  background-color: var(--col-highlight-bg);
}

.small-margin-bottom {
  margin-bottom: 0.5em;
}

.alert-box {
  background-color: var(--col-highlight-bg);
  padding: 1em 2em;
  border: 2px solid;
  border-image: var(--diia-gradient);
  border-image-slice: 1;
  display: inline-block;
  
  p:last-of-type {
    margin-bottom: 0;
  }
}

.text-center {
  text-align: center;
}

.check-legend {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 1em;
  vertical-align: middle;
  border-radius: 50%;
}

.interactive-bg {
  background-color: var(--col-interactive-bg);
}

.tiny-text {
  font-weight: 300;
}

.fucking-text {
    font-size: 0.8em;
}

.info-spoiler .caption h6 {
  font-weight: 300;
}


a.button {
    padding: 16px 40px;
    background: transparent;
    border-radius: 40px;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    border: 2px solid black;

    max-width: max-content;
    margin-top: 2em;

    &:focus, &:hover {
        color: white;
        background-color: black;
    }
}


</style>
